import { useLazyQuery } from "@apollo/client";
import { useState, useCallback } from "react";
import {
  GeocodeAddressDocument,
  GeocodedLocation,
} from "../../__generated__/graphql";

export default function useGeocodeAddress() {
  const [geocodedLocation, setGeocodedLocation] =
    useState<GeocodedLocation | null>(null);

  const [geocodeAddressQuery, { loading, error }] = useLazyQuery(
    GeocodeAddressDocument,
    {
      onCompleted: (data) => {
        setGeocodedLocation(data?.geocodeAddress || null);
      },
      onError: (error) => {
        console.error("Geocode address error:", error);
        setGeocodedLocation(null);
      },
    }
  );

  const geocodeAddress = useCallback(
    (address: string) => {
      return geocodeAddressQuery({
        variables: {
          geocodeAddressInput: {
            address,
          },
        },
      });
    },
    [geocodeAddressQuery]
  );

  const clearGeocodedLocation = useCallback(() => {
    setGeocodedLocation(null);
  }, []);

  return {
    geocodeAddress,
    geocodedLocation,
    loading,
    error,
    clearGeocodedLocation,
  };
}
